import React from "react";

const CustomDatePicker = ({ filters, onChange }) => {

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    onChange({
      ...filters,
      [name]: value,
    });
  };

  return (
    <div className="datepicker-wrapper">

      {/* From Date */}
      <div className="datepicker-container">
        <label className="filter-label">From Date</label>
        <input
          type="date"
          name="fromDate"
          value={filters.fromDate || ""}
          max={filters.toDate || undefined}
          onChange={handleDateChange}
          className="filter-select"
        />
      </div>

      {/* To Date */}
      <div className="datepicker-container">
        <label className="filter-label">To Date</label>
        <input
          type="date"
          name="toDate"
          value={filters.toDate || ""}
          min={filters.fromDate || undefined}
          onChange={handleDateChange}
          className="filter-select"
        />
      </div>

    </div>
  );
};

export default CustomDatePicker;


// WEBPACK FOOTER //
// src/modules/employee/Home/CustomDatePicker.js